import http from 'hub-http/clients/apiClient';
export function fetchFileById(id) {
  return http.get(`filemanager/api/v3/files/${id}`);
}